import { Steps } from 'intro.js-react';
import 'intro.js/introjs.css';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import * as Yup from 'yup';
import {
  MdClose,
  MdDomain,
  MdPermIdentity,
  MdCheckCircle,
  MdEmail,
  MdPhoneAndroid,
} from 'react-icons/md';
import {
  AiOutlineSafetyCertificate,
  AiOutlineArrowLeft,
  AiOutlineMail,
  AiOutlineQuestionCircle,
} from 'react-icons/ai';
import { toast } from 'react-toastify';
import { Formik } from 'formik';
import { BsChatLeft } from 'react-icons/bs';
import { useTour } from 'hooks/useTour';
import { TableWrap } from 'pages/BankSlip/styles';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import TextArea from 'components/layout/form/textArea';
import TextField from 'components/layout/form/textField';
import Loading from 'components/layout/loading';
import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import api from 'services/api';
import firebase from 'services/firebase';
import theme from 'styles/theme';
import { verifyUser } from 'utils/functions';
import {
  nameRegex,
  cellPhoneNumberWithMaskRegex,
  emailRegex,
  cellPhoneNumberRegex,
} from 'utils/regex';

import scrollBlock from 'utils/functions/scrollBlock';
import phoneMask from 'utils/phoneMask';
import { FAQOPTIONS } from './enuns';

import {
  ButtonContainer,
  ButtonText,
  Container,
  EditIcon,
  FieldName,
  Hr,
  Input,
  ModalContainer,
  ModalHeader,
  ModalStyle,
  Option,
  PageTitle,
  Select,
  SendButton,
  SubjectIcon,
  FormContainer,
  Error,
  TitleHome,
  SubTitleHome,
  HomeContainer,
  BoxIconContainer,
  BoxLinkContainer,
  BoxTextContainer,
  BoxSeparator,
  BackComponent,
  ButtonBack,
} from './styles';
import Faq from './Faq';

function Contato(props) {
  const formikRef = useRef(null);
  const history = useHistory();

  const [company, setCompany] = useState('');
  const [faqPages, setFaqPages] = useState(FAQOPTIONS.home);
  const [name, setName] = useState(null);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [reason, setReason] = useState(null);
  const [message, setMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [loading, setLoading] = useState(false);
  const [stepResponsive, setStepResponsive] = useState(false);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [scrollBlockState, setScrollBlockState] = useState(null);
  const [initialValues, setInitialValues] = useState({
    name: '',
    reason: '',
    message: '',
  });

  const [reasons, setReasons] = useState({
    SUGESTAO: 'Sugestão',
    ELOGIO: 'Elogio',
    ABASTECIMENTO: 'Abastecimento',
    COMERCIAL: 'Comercial',
    ASSISTENCIA_TECNICA: 'Assistência Técnica',
    FINANCEIRO: 'Financeiro',
    CADASTRO: 'Cadastro',
  });

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    if (!showTour) return;
    setTourType('fale-conosco');
    setSteps(3);
  }, [showTour, setTourType, setSteps]);

  useEffect(() => {
    async function getAccessToken() {
      const token = await localStorage.getItem(
        '@UltragazEmpresarial:accessToken'
      );

      if (!token) {
        verifyUser(props);
      }
    }

    function getCompany() {
      const customerName = localStorage.getItem(
        '@UltragazEmpresarial:customerName'
      );
      setCompany(customerName);
    }

    function getEmail() {
      const loginEmail = localStorage.getItem(
        '@UltragazEmpresarial:loginEmail'
      );
      setEmail(loginEmail);
    }
    getAccessToken();
    getCompany();
    getEmail();
  }, []);

  useEffect(() => {
    setInitialValues({ ...initialValues, email });
  }, [email]);

  useEffect(() => {
    setInitialValues({ ...initialValues, phone });
  }, [phone]);

  useEffect(() => {
    async function getContact() {
      try {
        await requestGetCustomer();
      } catch (error) {
        setLoading(false);
        const erro = error.response;
        if (erro) {
          const { message } = error.response.data;
          if (error.response.status !== 401) {
            toast.error(message);
          }
        } else if (error.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      }
    }
    getContact();
  }, []);

  const validationSchema = () =>
    Yup.object().shape({
      name: Yup.string()
        .matches(nameRegex, 'Digite o seu nome')
        .required('Digite o seu nome'),
      email: Yup.string()
        .matches(emailRegex, 'Digite um email válido')
        .required('Digite seu email'),
      phone: Yup.string()
        .matches(cellPhoneNumberWithMaskRegex, 'Digite um celular válido')
        .required('Digite seu celular'),
      reason: Yup.string().required('Selecione um motivo'),
      message: Yup.string().required('Digite a sua mensagem'),
    });

  const requestGetCustomer = useCallback(async () => {
    setLoading(true);

    const siteId = localStorage.getItem('@UltragazEmpresarial:customerSiteId');

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
      type: 'EMP',
      _expand: 'CONTACT',
    };

    const response = await api.get(
      'industrial/customer/v1/customers/me',
      parameters
    );

    const {
      data: { customerAddresses },
    } = response;

    const [address] = customerAddresses.filter(
      (customerAddress) =>
        customerAddress.addressType === 'SHIP_TO' &&
        customerAddress.siteId === siteId
    );

    if (!address) {
      return setLoading(false);
    }

    const { contacts } = address;

    if (contacts.length > 0) {
      const [phone] = contacts.filter(
        (contact) =>
          contact.contactType === 'PHONE' && contact.isValidated === true
      );

      if (!phone) {
        return setLoading(false);
      }
      const contactPhone = phoneMask(phone.contact);
      setPhone(contactPhone);
    }
    setLoading(false);
  }, []);

  function handleSetStepResponsive() {
    if (window.matchMedia('(max-width: 1100px)').matches) {
      stepResponsive = true;
    } else {
      stepResponsive = false;
    }
  }

  async function handleSubmit(
    { name, email, phone, reason, message: detail },
    { resetForm }
  ) {
    setLoading(true);

    const header = {
      'Content-Type': 'application/json',
      access_token: await localStorage.getItem(
        '@UltragazEmpresarial:accessToken'
      ),
    };

    firebase.analytics().logEvent('fale_conosco', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });

    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        fale_conosco: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });

    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        fale_conosco: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });

    try {
      const contactIdSf = localStorage.getItem(
        '@UltragazEmpresarial:contactIdSf'
      );

      const body = {
        customerSiteId: localStorage.getItem(
          '@UltragazEmpresarial:customerSiteId'
        ),
        name,
        email,
        phone,
        reason,
        detail,
        origin: 'PORTAL_API',
        ...(contactIdSf && { contactIdSf }),
      };

      const response = await api.post(`industrial/case/v1/contact-us`, body, {
        headers: header,
      });

      if (response.status === 201) {
        const { location } = response.headers;
        const caseId = location.split('/').pop();

        if (caseId) {
          const params = {
            method: 'GET',
            headers: header,
          };

          setLoading(false);

          const caseResponse = await api.get(location, params);

          if (caseResponse.status === 200) {
            const caseData = caseResponse.data;
            setShowModal(true);
            setModalData(caseData);
          } else {
            toast.success('Seu caso foi criado com sucesso!');
          }
        } else {
          setLoading(false);
          toast.info(
            'O caso foi criado! Mas não identificamos o número de protocolo.'
          );
        }
      }
    } catch (err) {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const message = err.response.data[0]
          ? err.response.data[0].message
          : err.response.data.message;

        const status = err.response.data[0]
          ? err.response.data[0].status
          : err.response.data.status;

        if (status !== 401) {
          toast.error(message);
        }
      } else {
        const status = err.response?.status || false;
        if (status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      }
    } finally {
      resetForm();
    }
  }

  function onExit() {
    setStepsEnabled(false);
    const newScrollBlock = false;
    setScrollBlockState(newScrollBlock);
    scrollBlock('#outer-container', 'body', newScrollBlock);
  }

  function toggleSteps() {
    handleSetStepResponsive();
    setStepsEnabled((prevState) => !prevState);
    const newScrollBlock = false;
    setScrollBlockState(newScrollBlock);
    scrollBlock('#outer-container', 'body', newScrollBlock);
  }

  function handleChangeView(view) {
    setFaqPages(view);
  }

  function handleClickOpenChat() {
    const chatbotButton = document?.querySelector('#hi-custom-widget');
    if (chatbotButton) {
      chatbotButton.click();
    }
  }

  return (
    <>
      <Navbar selected="contato">
        <UserMenu breadcrump="› FAQ" />

        {faqPages === FAQOPTIONS.home && (
          <Container>
            <TitleHome>Olá! Como podemos lhe ajudar?</TitleHome>
            <SubTitleHome>
              Selecione a melhor opção para lhe atendermos
            </SubTitleHome>
            <TableWrap
              showTour={
                showTour && tourType === 'fale-conosco' && tourStep === 3
              }
            >
              <HomeContainer>
                <BoxLinkContainer
                  onClick={() => handleChangeView(FAQOPTIONS.faq)}
                >
                  <BoxIconContainer>
                    <AiOutlineQuestionCircle size={48} color="#000eff" />
                  </BoxIconContainer>
                  <BoxSeparator />
                  <BoxTextContainer>Dúvidas</BoxTextContainer>
                  <BoxTextContainer>frequentes</BoxTextContainer>
                </BoxLinkContainer>
                <BoxLinkContainer onClick={() => handleClickOpenChat()}>
                  <BoxIconContainer>
                    <BsChatLeft size={48} color="#000eff" />
                  </BoxIconContainer>
                  <BoxSeparator />
                  <BoxTextContainer>Falar</BoxTextContainer>
                  <BoxTextContainer>via chat</BoxTextContainer>
                </BoxLinkContainer>
                <BoxLinkContainer
                  onClick={() => history.push('/dicas-seguranca')}
                >
                  <BoxIconContainer>
                    <AiOutlineSafetyCertificate size={48} color="#000eff" />
                  </BoxIconContainer>
                  <BoxSeparator />
                  <BoxTextContainer>Dicas de</BoxTextContainer>
                  <BoxTextContainer>segurança</BoxTextContainer>
                </BoxLinkContainer>
              </HomeContainer>
              {showTour && tourType === 'fale-conosco' && tourStep === 3 && (
                <TourBalloon
                  title="Fale Conosco"
                  content="Aqui você pode selecionar as dúvidas frequentes, ou acionar a Ully para sanar suas dúvidas."
                  position={{
                    left: '0',
                    right: '0',
                    top: '96%',
                    arrowPosition: 'top',
                    maxWidth: null,
                    boxShadow: false,
                  }}
                />
              )}
            </TableWrap>
          </Container>
        )}

        {faqPages === FAQOPTIONS.faq && (
          <Container>
            <div
              className="intro-contato"
              style={{
                paddingBottom: '64px',
              }}
            >
              <div
                style={{
                  margin: '24px 0',
                }}
              >
                <TitleHome>Dúvidas frequentes</TitleHome>
                <SubTitleHome>
                  Selecione a que faz mais sentido para você!
                </SubTitleHome>
              </div>
              <Faq />
              <ButtonBack onClick={() => handleChangeView(FAQOPTIONS.home)}>
                Voltar
              </ButtonBack>
            </div>
          </Container>
        )}
      </Navbar>

      <ModalStyle
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        centered
      >
        <ModalContainer>
          <ModalHeader>
            <div>
              <MdCheckCircle size={50} color={theme.colors.lightGreen} />
              <h2>
                {`Sua solicitação sobre ${
                  reasons[modalData.reason]
                } foi registrada através do protocolo: ${modalData.caseNumber}.
                Retornaremos o contato em até 48 horas através do seu e-mail
                e/ou telefone.`}
              </h2>
              <MdClose
                size={24}
                onClick={() => {
                  setShowModal(false);
                }}
              />
            </div>
          </ModalHeader>
        </ModalContainer>
      </ModalStyle>
    </>
  );
}

export default Contato;
